module.exports = __webpack_public_path__ + "img/arrow-blue.a0f98396.svg";